export default "__VITE_ASSET__CnHYW8mz__"